{
  "en": {
    "integration": {
      "actions": {
        "goTo": "Go to {name}"
      },
      "labels": {
        "apiTokensUsedByYou": "API tokens",
        "create_failed": "Failed to create",
        "crm_id": "{integration_oid_type} ID in {integration_name}: {integration_oid}",
        "description": "Description",
        "error": "error",
        "integration": "Integration",
        "integrationOID": "Integration ID",
        "last_sync_with": "Last synchronization with {integration_name} ({last_sync_at})",
        "status": "status",
        "synced_at": "Last synchronization: ",
        "title": "Integrations managed by Ziggu",
        "update_failed": "failed to update"
      },
      "record_actions": {
        "assign_customer": "Assign the customer in {integration_name}. Customer linking is managed there.",
        "delete": "For the {record_type} to be permanently deleted on Ziggu (and not reappear), the {record_type} <strong>should first be deleted on {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integration updated"
      }
    }
  }
}
